import React, {Component} from 'react'
import propTypes from 'prop-types'
import {prefix} from 'helpers/component'
import GroupHeaders from "./groupHeaders"
import {get, isNil} from 'lodash'

const getClassName = prefix('pivotTable-group-')

// Offsets the group headers below the pivot table's own header rows
const STICKY_OFFSET_WITH_HEADER = 51
const STICKY_OFFSET_WITHOUT_HEADER = 41

class Group extends Component {

    render() {
        const {
            children,
            index,
            column,
            group,
            expanded,
            showSelector,
            count,
            onToggle,
            theme,
            visibleColumns,
            allColumns,
            columnSizes,
            fullSize,
            showHeader,
            controlColumns,
            onColumnSize,
            onColumnMove,
            actionColumns,
            stickyTop,
            visibleTotalGroupFields,
        } = this.props

        let label = get(group, 'value', null)
        const groupData = get(group, 'data', {})

        if (groupData.length > 0) {
            const columnGroupData = get(column, 'groupData', null)
            label = columnGroupData ? column.groupData(groupData[0]) : column.data(groupData[0])
        }

        const columnLabel = get(column, 'label', null)
        const preLabel = columnLabel && columnLabel.length > 0 &&
            <span className={getClassName('preLabel')}>{columnLabel}:</span>

        const postLabel = count && <span className={getClassName('postLabel')}>({count})</span>

        const classes = ['container']

        if (index > 0)
            classes.push('container-secondary')

        const content = (expanded || !showSelector) ? children : null

        return (
            <div className={getClassName(classes)}>
                <GroupHeaders
                    theme={theme}
                    columns={visibleColumns.map(c => allColumns[c])}
                    visibleTotalGroupFields={visibleTotalGroupFields}
                    columnSizes={columnSizes}
                    groupData={group}
                    preLabel={preLabel}
                    label={label}
                    postLabel={postLabel}
                    showSelector={showSelector}
                    expanded={expanded}
                    onToggle={onToggle}
                    columnReorderAllowed={true}
                    columnResizingAllowed={true}
                    fullSize={fullSize}
                    stickyTop={isNil(stickyTop)
                        ? undefined
                        : stickyTop + (showHeader ? STICKY_OFFSET_WITH_HEADER : STICKY_OFFSET_WITHOUT_HEADER)}
                    controlColumns={controlColumns}
                    actionColumns={actionColumns}
                    onSize={onColumnSize}
                    onMove={onColumnMove}
                />
                {content}
            </div>
        )
    }
}

Group.propTypes = {
    column: propTypes.object.isRequired,
    group: propTypes.object.isRequired,
    index: propTypes.number.isRequired,
    expanded: propTypes.bool.isRequired,
    showSelector: propTypes.bool,
    onToggle: propTypes.func,
    count: propTypes.number,
    children: propTypes.any,
    theme: propTypes.object,
    visibleColumns: propTypes.array,
    allColumns: propTypes.object.isRequired,
    columnSizes: propTypes.object.isRequired,
    fullSize: propTypes.bool,
    showHeader: propTypes.bool,
    controlColumns: propTypes.array,
    onColumnSize: propTypes.func,
    onColumnMove: propTypes.func,
    actionColumns: propTypes.array,
    visibleTotalGroupFields: propTypes.array,
    stickyTop: propTypes.number,
}

Group.defaultProps = {
    showSelector: true,
    visibleTotalGroupFields: [],
}

export default Group
